import { render, staticRenderFns } from "./FormSteps.vue?vue&type=template&id=1bc6d7ec"
import script from "./FormSteps.vue?vue&type=script&lang=js"
export * from "./FormSteps.vue?vue&type=script&lang=js"
import style0 from "./FormSteps.vue?vue&type=style&index=0&id=1bc6d7ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports